import { render, staticRenderFns } from "./recursos.vue?vue&type=template&id=72eed4d2"
import script from "./recursos.vue?vue&type=script&lang=js"
export * from "./recursos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports